export enum LocationTypeName {
  ImportFromCSV = 'Import From CSV',
  MasterLocation = 'Master Location',
  ManualEntry = 'Manual Entry',
}
